<template>
	<div class="indexbg">
		<topbar></topbar>
		<sortHeader></sortHeader>
		<div class="clear mt15"></div>
		<!--container 开始-->
		<div class="w1200 bc">
		    <!--购物车：开始-->
		    <div class="hq-shopping-cart">
		        <!--购物流程：开始-->
		        <div class="hq-reg-step">
		            <ul class="ico">
		                <li>
		                	<p class="item">购物车</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li>
		                	<p class="item">提交订单</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li>
		                	<p class="item">确认付款</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li class="active">
		                	<p class="item">下单成功</p>
		                    <i class="step-count"></i>
		                </li>
		            </ul>
		        </div>
		    
		    <div class="tipsbox success" style="padding: 0;height: 500px;">
		    	<div class="order clearfix order-init order-init-oldUser-noQrcode">
				    <!-- 订单信息 -->
				    <div class="o-left"><h3 class="o-title">订单提交成功，请尽快付款！</h3></div>
				    <!-- 订单信息 end --><!-- 订单金额 -->
				    <div class="o-right" style="float: left;">
				        <div class="o-price"><em>应付金额</em><strong>{{(total_fee/100).toFixed(2)}}</strong><em>元</em></div>
				    </div>
				    <div class="o-right" style="width: 286px;float: left;padding: 32px 10px 0px 10px;">
				        <a style="font-size: 14px;color: #df3134;" @click="goOrder('wait_send_goods')">查看订单&nbsp;></a>
					    <a style="font-size: 14px;margin-left: 10px;color: #df3134;" :href="indexUrl" >返回首页&nbsp;></a>
				    </div>
				</div>
		        <div class="payment">
		            <!-- 微信支付 -->
		            <div class="pay-weixin">
		                <div class="p-w-bd" style="position:relative">
		                    <div class="p-w-box">
		                        <div class="pw-box-hd">
		                            <canvas id="canvas"></canvas>
		                        </div>
		                        <div class="pw-retry j_weixiRetry" style="display: none;">
		                            <a class="ui-button ui-button-gray j_weixiRetryButton" href="javascript:getWeixinImage2();">获取失败 点击重新获取二维码  </a>
		                        </div>
		                        <div class="pw-box-ft">
		                            <p>请使用微信扫一扫</p>
		                            <p>扫描二维码支付</p>
		                        </div>
		                    </div>
		                    <div class="p-w-sidebar"></div>
		                </div>
		            </div>
		        </div>
		    </div>
		    </div>
			<div class="clear"></div>
		    <div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
		</div>
		<!--container 结束-->

		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>

<script>
	/*引入Vue框架*/
	import Vue from 'vue'
	/*引入资源请求插件*/
	import VueResource from 'vue-resource'
	/*使用VueResource插件*/
	Vue.use(VueResource)
	import TopBar from '@/components/TopBar'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	import alertConfirm from "../../../static/js/alertConfirm.js"
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getCmsUrl,getAboutUsUrl,getEmallUrl,getUcUrl} from "../../../static/js/emallUtils.js"
	import API from "../../../static/api/api.js"
	import QRCode from 'qrcode';
	Vue.use(QRCode);
	export default {
	  name: 'payScanQrcode',
	  data () {
	    return {
	    	code_url:"",
	    	total_fee:"",
	    	package_code:"",
	    	interval:null,
	    	indexUrl:"",
			orderUrl:""
	    }
	  },
	  components:{
	  		'topbar': TopBar,
			'sortHeader':Header,
			'footermenu':FooterMenu,
			'footercopyright':FooterCopyright
	  },
	  methods:{
	  	goOrder:function(tradeStatus){
			var account = localStorage.getItem("account");
			if(account != undefined && account != ""){
				window.location.href=this.orderUrl+"?tradeStatus="+tradeStatus;
			}else{
				window.location.href=getUcUrl()+'/login.htm';
			}
		},
	  	viewAllOrders: function(){
			window.location.href = getEmallUrl() + '/orderManage/myOrderList.htm';
		},
		generateQrCode:function(){
			var that = this;
			var canvas = document.getElementById('canvas');
			QRCode.toCanvas(canvas,that.code_url, {
				errorCorrectionLevel: "H",
				width: 300
			}, function(error) {
				if(error) console.error(error)
				console.log('success!');
			});
		},
		ListenPayStatus:function(){
			var that = this;
			 that.interval = setInterval(function(){
				API.checkPayStatus(that.package_code,function(ret){
					if(ret.code == "success"){
						clearInterval(that.interval);
						that.$router.push({ name: 'paySuccess', params:{}});
					}else if(ret.code == "fail"){
						alertConfirm.singleConfirm("查询支付订单异常！");
						clearInterval(that.interval);
					}
				});
			},2000);
		}
	  },
	  beforeMount: function() {
			var that = this;
			if(this.$route.params.code_url != undefined){
				that.code_url = this.$route.params.code_url;
			}
			if(this.$route.params.total_fee != undefined){
				that.total_fee = this.$route.params.total_fee;
			}
			if(this.$route.params.package_code != undefined){
				that.package_code = this.$route.params.package_code;
			}
		},
		beforeRouteLeave(to,form,next){
			clearInterval(this.interval);
			next();
		},
	   mounted(){
			window.scrollTo(0, 0);
			this.indexUrl = getCmsUrl();
			this.orderUrl = getEmallUrl() + '/orderManage/myOrderList.htm';
			this.generateQrCode();
			this.ListenPayStatus();
	   }
	}
</script>

<style scoped>
.order {
    position: relative;
}
.order.order-init .o-left {
    padding-left: 0;
    transition: all .15s ease-in-out;
}
.order .o-left {
    float: left;
    width: 640px;
    padding-left: 102px;
}
.order .o-title {
    line-height: 26px;
    height: 26px;
    overflow: hidden;
    color: #333;
    font-weight: 400;
    font-size: 14px;
    font-family: "Microsoft Yahei";
}
.order.order-init.order-init-oldUser-noQrcode .o-tips {
    visibility: visible;
    opacity: 1;
}
.order.order-init .o-tips {
    visibility: hidden;
    opacity: 0;
    transition: all .2s ease-in-out;
}
.order .o-tips {
    line-height: 20px;
    height: 20px;
}
.order .o-right {
    width: 190px;
    padding-top: 32px;
    padding-bottom: 10px;
    padding-right: 10px;
}
.order .o-price {
    text-align: right;
    line-height: 26px;
}
.order .o-price em {
    vertical-align: bottom;
}

em {
    font-style: normal;
}
.order .o-price strong {
    font-size: 18px;
    vertical-align: bottom;
    color: #e31613;
    margin: 0 3px;
}
.order .o-price em {
    vertical-align: bottom;
}
em {
    font-style: normal;
}
.payment {
    background-color: #fff;
    padding: 12px 30px;
}
.p-w-bd, .pay-weixin {
    zoom: 1;
}
.p-w-hd {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: "Microsoft Yahei";
}
.p-w-bd {
    padding-left: 130px;
}

.p-w-bd, .pay-weixin {
    zoom: 1;
}
.font-red {
    color: #e31613;
}
.p-w-box {
    float: left;
    width: 300px;
}
.pw-box-hd {
    margin-bottom: 20px;
    width: 298px;
    height: 298px;
}
.order_btn {
    display: inline-block;
    margin: 0 5px;
    padding: 0 30px;
    height: 38px;
    line-height: 38px;
    border: solid 1px #1478ae;
    color: #1478ae;
    border-radius: 20px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/page/order/payScanQrcode.vue